import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { TerminalsParametersTable } from "./TerminalsParametersTable";

export const ParametersTableField: FieldMethod = ({ field }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name}>
            <TerminalsParametersTable key={field.name} />
        </Form.Item>
    );
};
